import React, { useCallback } from 'react'
import { useSelector, useStore } from 'react-redux'
import { moduleContext } from 'react-contextual'
import { userApiEvents, userApiSelectors } from '../api/user'
import { apiStateSelectors } from '../api/apiState'
import { $TSFixMe } from 'types/ts-migrate'
import { events, selectors } from './state'

const AgencySwitcherProvider = moduleContext()(({ context, children, ...props }: any) => {
  const store = useStore()
  const { dispatch } = store

  const agenciesForSwitching: $TSFixMe[] = useSelector(userApiSelectors.getAgencies)

  const agencySwitcherStore = {
    isAgencySwitcherModalOpen: useSelector(selectors.isAgencySwitcherModalOpen),
    agenciesForSwitching,
    currentAgencyId: useSelector(userApiSelectors.getCurrentAgencyId),
    isSwitchingAgency: useSelector((state: $TSFixMe) =>
      apiStateSelectors.isLoading(state)([userApiEvents.switchAgency_request]),
    ),

    openAgencySwitcherModal: useCallback(() => dispatch(events.open()), [dispatch]),
    closeAgencySwitcherModal: useCallback(() => dispatch(events.close()), [dispatch]),
    fetchAgenciesForSwitching: useCallback(() => dispatch(userApiEvents.getAgencies_request()), [dispatch]),
    switchAgency: useCallback(
      ({ agencyId }) => {
        dispatch(userApiEvents.switchAgency_request({ id: agencyId }))
      },
      [dispatch],
    ),
    ...props,
  }
  return <context.Provider value={agencySwitcherStore}>{children}</context.Provider>
})

export default AgencySwitcherProvider
